import React from 'react';
import type { FC } from 'react';
import { brand } from '../config';

interface LogoProps {
  [key: string]: any;
}

const Logo: FC<LogoProps> = (props) => {
  return (
    <img
      alt="Logo"
      src={brand.logo}
      {...props}
    />
  );
};

export default Logo;
